import { DeviceEnum } from '@modules/filters/enums';

export const deviceLabel = {
  [DeviceEnum.Mobile]: 'Mobile',
  [DeviceEnum.Laptop]: 'Laptop',
  [DeviceEnum.MobileLaptop]: 'Mobile + Laptop',
  [DeviceEnum.LaptopMobile]: 'Laptop + Mobile'
};
